import { render, staticRenderFns } from "./RelatorioCpk.vue?vue&type=template&id=6217bcd2&scoped=true&"
import script from "./RelatorioCpk.vue?vue&type=script&lang=js&"
export * from "./RelatorioCpk.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioCpk.vue?vue&type=style&index=0&id=6217bcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6217bcd2",
  null
  
)

export default component.exports